var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{field: _vm.size !== 'invisible'}},[_c('vue-recaptcha',{ref:"recaptcha",staticClass:"recaptcha",attrs:{"sitekey":_vm.useSiteKey,"load-recaptcha-script":true,"size":_vm.size},on:{"expired":_vm.onExpired,"verify":_vm.onVerify}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }